import { ja } from './ja';
import { en } from './en';
import { zh } from './zh';
import { es } from './es';

export const locales = { ja, en, zh, es };
export type Locale = keyof typeof locales;
export type LocaleKeys = keyof typeof ja;